export var MembershipLevelPosition;
(function (MembershipLevelPosition) {
    MembershipLevelPosition[MembershipLevelPosition["High"] = 3] = "High";
    MembershipLevelPosition[MembershipLevelPosition["Middle"] = 2] = "Middle";
    MembershipLevelPosition[MembershipLevelPosition["Low"] = 1] = "Low";
})(MembershipLevelPosition || (MembershipLevelPosition = {}));
export const colorNames = [
    'Red', 'Pink', 'Purple', 'Deep-Purple', 'Indigo', 'Blue', 'Light-Blue', 'Cyan', 'Teal', 'Green', 'Light-Green', 'Lime', 'Yellow', 'Amber', 'Orange', 'Deep-Orange', 'Brown', 'Grey', 'Blue-Grey'
];
export const helpText = {
    membershipLevel: {
        price: {
            [MembershipLevelPosition.Low]: "Relative to your average order value,<br/>the lowest tier should feel like a tip",
            [MembershipLevelPosition.Middle]: "Relative to your average order value,<br/>the middle tier should feel like adding<br/>an extra product to your cart",
            [MembershipLevelPosition.High]: "Relative to your average order value,<br/>the highest tier should be for VIPs,<br/>as valuable as whatever they're buying",
        },
        discount: "We believe that tiers with discounts sell 4x as much,<br/>and the subscribers make 43% more purchases",
        subscriptionBox: {
            [MembershipLevelPosition.Low]: "We suggest a yearly subscription box for the lowest tier, like a holiday gift for your supporters.",
            [MembershipLevelPosition.Middle]: "We suggest a quarterly subscription box for the middle tier.<br/>Essentially, subscribers receive the highest tier<br/>subscription box on a payment plan.",
            [MembershipLevelPosition.High]: "We suggest a monthly subscription box at the highest tier.<br/>Consider that the price includes shipping,<br/> and Withfriends' 10% commission fee.",
        },
        welcomeGift: "Add a welcome package that subscribers receive once when they sign up",
        writeInBenefit: "Add additional perks to give your members a VIP experience."
    }
};
